import React from 'react';
import { FileCheckIcon, GaugeIcon, ZapIcon } from 'lucide-react';
import { Card, CardLabel, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
const pillars = [{
  icon: FileCheckIcon,
  label: 'No new medical content',
  body: 'We snakify existing, pre approved long-form materials, so nothing new enters the medical pipeline. MLR sees familiar claims in a new format, keeping reviews short and predictable.',
  accent: 'var(--brand-green-lighter)'
}, {
  icon: ZapIcon,
  label: 'The campaign engine',
  body: 'Adaptation, localization and deployment are part of our model, never an add on. We work alongside local teams to get campaigns live fast and hand them the impact in their own market.',
  accent: 'var(--brand-green-light)'
}, {
  icon: GaugeIcon,
  label: 'Control Tower governance',
  body: 'One hub to publish, govern and compare every brand, market and campaign. Central teams gain oversight and reusable learnings instead of another project to chase.',
  accent: 'var(--brand-green)',
  footnote: 'Annual license: €50,000'
}];
export function ControlTowerSlide() {
  return <Slide data-id="element-61" data-mp="lc46i5nlry0e">
      <SlideHeader eyebrow="Keeping the internal lift light" data-id="element-62" data-mp="lbue6bf35erj">
        Central teams get visibility and control,{' '}
        <Hi data-id="element-63" data-mp="qd1lyah8ady7">not another project to manage.</Hi>
      </SlideHeader>

      <div className="grid min-h-0 flex-1 grid-cols-3 gap-[clamp(1rem,1.8vw,1.75rem)]" data-id="element-64" data-mp="vbcy4ruzx0jl">
        {pillars.map((pillar, index) => <Fade key={pillar.label} delay={0.2 + index * 0.12} className="flex" data-id="element-65" data-mp="14agis09t9o07" data-mpi={index}>
            <Card className="flex flex-1 flex-col" data-id="element-66" data-mp="148djepmrqiit">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full" style={{
            backgroundColor: pillar.accent
          }} data-id="element-67" data-mp="190wwllhjnbn3">
                <pillar.icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-68" data-mp="1izw7laps7jd9" />
              </div>
              <h3 className="text-[clamp(1.05rem,1.5vw,1.5rem)] font-bold leading-tight text-[var(--fg)]" data-id="element-69" data-mp="1n0g2s8qsocwr">
                {pillar.label}
              </h3>
              <p className="mt-3 text-[clamp(0.95rem,1.25vw,1.25rem)] leading-relaxed text-[var(--muted)]" data-id="element-70" data-mp="3jzhktdwmc1x7">
                {pillar.body}
              </p>
              {pillar.footnote ? <div className="mt-auto pt-4" data-id="element-71" data-mp="3sv72pcyuye5u">
                  <CardLabel data-id="element-72" data-mp="3o2np4g067j11">{pillar.footnote}</CardLabel>
                </div> : null}
            </Card>
          </Fade>)}
      </div>

      <Fade delay={0.6} className="mt-[clamp(1rem,1.8vw,1.75rem)] flex-shrink-0" data-id="element-73" data-mp="6osb3vlbdx1g">
        <p className="border-l-2 border-[var(--brand-green)] pl-4 text-[clamp(1rem,1.5vw,1.5rem)] font-semibold text-[var(--fg)]" data-id="element-74" data-mp="1n2wy72sp395">
          One engine, one viewpane, every market moving at the same speed.
        </p>
      </Fade>
    </Slide>;
}